import { useCallback, useEffect, useState } from 'react';
import { api, ApiError } from '../lib/apiClient.js';

export interface SiteGateSession {
  loading: boolean;
  enabled: boolean;
  unlocked: boolean;
  error: string | null;
  unlock: (username: string, password: string) => Promise<boolean>;
}

/** שער "בקרוב" — כבוי כברירת מחדל; דלוק רק כשהשרת מדווח SITE_USERNAME/SITE_PASSWORD מוגדרים */
export function useSiteGate(): SiteGateSession {
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);
  const [unlocked, setUnlocked] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get<{ enabled: boolean; unlocked: boolean }>('/api/site/status')
      .then((res) => {
        if (cancelled) return;
        setEnabled(res.enabled);
        setUnlocked(res.unlocked);
      })
      .catch(() => {
        // כשל רשת — לא נועלים משתמש אמיתי בגלל בעיית תקשורת חולפת
        if (!cancelled) {
          setEnabled(false);
          setUnlocked(true);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const unlock = useCallback(async (username: string, password: string) => {
    setError(null);
    try {
      await api.post('/api/site/unlock', { username, password });
      setUnlocked(true);
      return true;
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'שגיאת חיבור — נסה שוב');
      return false;
    }
  }, []);

  return { loading, enabled, unlocked, error, unlock };
}
